import { Container } from './style';

export function SpaceLoader({ colorLoader = "#535354" }) {
  return(
        <Container colorLoader={colorLoader}>
            
        </Container>
  )
}

